// Real Google reviews for Behson Property Solutions, copied from the Google Business Profile.
// Dates are intentionally omitted so nothing on the site goes stale.
// To add a review: copy the reviewer's display name, star rating and text exactly as shown on Google.

export interface RealGoogleReview {
  author_name: string;
  rating: number;
  text: string;
  profile_photo_url?: string;
}

/** Total review count and average as shown on the Google Business Profile. Update when it changes. */
export const googleRatingSummary = {
  rating: 5.0,
  count: 7,
  profileUrl: 'https://www.google.com/maps/search/?api=1&query=Behson+Property+Solutions',
};

export const realGoogleReviews: RealGoogleReview[] = [
  {
    author_name: 'Parviz Toserkani',
    rating: 5,
    text:
      'I have a property company. I have used his services for a number of jobs over the years and have always been very happy with the work. He is extremely reliable, hardworking and knowledgeable, and is able to deal with a wide range of jobs.',
  },
  {
    author_name: 'Raydin Ranasinghe',
    rating: 5,
    text: 'Brilliant job on my patio flooring and such a friendly workforce, would highly recommend. Thank you Behson Property Solutions.',
  },
  {
    author_name: 'Daniel DWH',
    rating: 5,
    text: 'Really impressed with the quality of work and professionalism from Behson Property Solutions, highly recommend their services!',
  },
  {
    author_name: 'Abinayan Rasthaylan',
    rating: 5,
    text:
      'I was able to do an amazing looking exterior redesign of my garden. I was really pleased with the result and they were very thorough with their work. 10/10',
  },
  {
    author_name: 'wasi',
    rating: 5,
    text: 'Very helpful man, was able to do a kitchen extension on my home and it looks wonderful. Will definitely contact again for future projects.',
  },
  {
    author_name: '1st Choice Coach Hire',
    rating: 5,
    text: 'Mehrdad and his team were great! Will definitely be using them again.',
  },
];

/** Reviews with enough text to feature in a card (the seventh Google review is a star rating with no text). */
export const getLatestReviews = (count: number = 3): RealGoogleReview[] => realGoogleReviews.slice(0, count);
